$(document).ready(function () {
  $("ul.tabs").each(function () {
    var t,
      i,
      a = $(this).find("a");
    (t = a.first().addClass("active")),
      (i = $(t.attr("href"))),
      a.not(":first").each(function () {
        $($(this).attr("href")).hide();
      }),
      $(this)
        .find("a")
        .click(function (a) {
          return (
            t.removeClass("active"),
            i.hide(),
            (t = $(this)),
            (i = $($(this).attr("href"))),
            t.addClass("active"),
            i.show(),
            !1
          );
        });
  });
});
